module.exports = __webpack_public_path__ + "static/img/about-certificate-08.efa4677.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/about-certificate-08.jpg
// module id = pTny
// module chunks = 1